import Vue from "vue";
import Router from "vue-router";
import $store from "../store/store";
import Home from "@/components/Home";
import Merchants from "@/components/Merchants";
import TransactionDetail from "@/components/TransactionDetail";
import SettledTransactionDetail from "@/components/SettledTransactionDetail";
import PaymentSuccess from "@/components/PaymentSuccess";
import PaymentFailure from "@/components/PaymentFailure";
import Profile from "@/components/Profile";
import ProfileMobile from "@/components/ProfileMobile";
import Paymenthistory from "@/components/Paymenthistory";
import Refunds from "@/components/Refunds";
import PaymentType from "@/components/PaymentType";
import RewardPoints from "@/components/RewardPoints";
import PerformDMI from "@/components/PerformDMI";
import InviteAndUpgrade from "@/components/InviteAndUpgrade";
import DMIStep1 from "@/components/DMIStep1";
import DMIStep2 from "@/components/DMIStep2";
import Prepaid from "@/components/Prepaid";
import Mobile from "@/components/Mobile";
import DTH from "@/components/DTH";
import DataCard from "@/components/DataCard";
import PostpaidWeb from "@/components/PostpaidWeb";
import Plan from "@/components/Plan";
import ChoosePlan from "@/components/ChoosePlan";
import Postpaid from "@/components/Postpaid";
import State from "@/components/State";
import Board from "@/components/Board";
import Bill from "@/components/Bill";
import FetchBill from "@/components/FetchBill";
import EplNewDashboard from "@/components/EplNewDashboard";
import EplNewPayment from "@/components/EplNewPayment";
import EplNewPayNow from "@/components/EplNewPayNow";
import EplNewPayCustom from "@/components/EplNewPayCustom";
import EplNewViewDetails from "@/components/EplNewViewDetails";
import TransactionStatus from "@/components/TransactionStatus";
import EplNewStatementFilter from "@/components/EplNewStatementFilter";
import EplNewStatement from "@/components/EplNewStatement";
import EplNewProfile from "@/components/EplNewProfile";
import MobileWeb from "@/components/MobileWeb";
import ChoosePlanWeb from "@/components/ChoosePlanWeb";
import DTHWeb from "@/components/DTHWeb";
import DataCardWeb from "@/components/DataCardWeb";
import EplNewPaymentSuccess from "@/components/EplNewPaymentSuccess";
import EplNewPaymentFailure from "@/components/EplNewPaymentFailure";
import EplNewPaymentPending from "@/components/EplNewPaymentPending";
import StateWeb from "@/components/StateWeb";
import FetchBillWeb from "@/components/FetchBillWeb";
import BoardWeb from "@/components/BoardWeb";
import BillWeb from "@/components/BillWeb";
import TransactionStatusWeb from "@/components/TransactionStatusWeb";
import EplNewTransaction from "@/components/EplNewTransaction";
import EplNewTransactionSuccess from "@/components/EplNewTransactionSuccess";
import EplNewTransactionFail from "@/components/EplNewTransactionFail";
import EplNewTransactionPending from "@/components/EplNewTransactionPending";
import EplNewInviteAndUpgrade from "@/components/EplNewInviteAndUpgrade";
import EplNewRewardPoints from "@/components/EplNewRewardPoints";
import EplNewMerchants from "@/components/EplNewMerchants";
import Signup from "../components/Signup";
import SignupVerifyOTP from "../components/SignupVerifyOTP";
import SignupPersonalDetails from "../components/SignupPersonalDetails";
import SignupEmploymentDetails from "../components/SignupEmploymentDetails";
import SignupVerifyOTPEmail from "../components/SignupVerifyOTPEmail";
import SignupLoader from "../components/SignupLoader";
import SignupSuccess from "../components/SignupSuccess";
import SignupFailure from "../components/SignupFailure";
import SignupPending from "../components/SignupPending";
import eMandate from "@/components/eMandate";
import SignupKyc from "@/components/SignupKyc";
import SignupKycStep1 from "@/components/SignupKycStep1";
import SignupKycStep2 from "@/components/SignupKycStep2";
import eMandateSuccess from "@/components/eMandateSuccess";
import eMandateFailure from "@/components/eMandateFailure";
import eMandatePending from "@/components/eMandatePending";
import kycSuccess from "@/components/kycSuccess";
import kycFailure from "@/components/kycFailure";
import SignupBlocked from "@/components/SignupBlocked";
import Insurance from "@/components/Insurance";
import TransactionHistory from "@/components/TransactionHistory";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      alias: "/home",
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/settled-transactions",
      name: "SettledTransactions",
      component: Profile,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/payment-history",
      name: "Paymenthistory",
      component: Paymenthistory,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/refunds",
      name: "Refunds",
      component: Refunds,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/payment-type",
      name: "PaymentType",
      component: PaymentType,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/payment-success",
      name: "PaymentSuccess",
      component: PaymentSuccess,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/payment-failure",
      name: "PaymentFailure",
      component: PaymentFailure,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: ProfileMobile,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/transaction/:id",
      name: "TransactionDetail",
      component: TransactionDetail,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/settled/transaction/:id",
      name: "SettledTransactionDetail",
      component: SettledTransactionDetail,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/merchants",
      name: "Merchants",
      component: Merchants,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/reward-points",
      name: "RewardPoints",
      component: RewardPoints,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      }
    },
    {
      path: "/kyc",
      component: PerformDMI,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: false
      },
      children: [
        {
          path: "",
          redirect: "step-1",
          meta: {
            requiresAuth: true,
            v1: true,
            v2: false
          }
        },
        {
          path: "step-1",
          name: "step-1",
          component: DMIStep1,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: false
          }
        },
        {
          path: "step-2",
          name: "step-2",
          component: DMIStep2,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: false
          }
        }
      ]
    },
    /* {
      path: '/rewards',
      name: 'Rewards',
      component: Rewards
    }, */
    {
      path: "/invite-upgrade",
      name: "InviteAndUpgrade",
      component: InviteAndUpgrade,
      meta: {
        requiresAuth: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/dmi",
      redirect: () => {
        window.location.href =
          "https://play.google.com/store/apps/details?id=in.epaylater.android.consumer ";
      }
    },
    {
      path: "/prepaid",
      meta: {
        requiresAuth: true,
        v1: true,
        v2: true
      },
      name: "prepaid",
      component: Prepaid,
      children: [
        {
          path: "Mobile",
          name: "Mobile",
          component: Mobile,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: "DTH",
          name: "DTH",
          component: DTH,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: "DataCard",
          name: "DataCard",
          component: DataCard,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":type/plan",
          name: "View Plans",
          component: Plan,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":type/choose-plan",
          name: "ChoosePlan",
          component: ChoosePlan,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":type/TransactionStatus",
          name: "TransactionStatus",
          component: TransactionStatus,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          path: ":type/Success",
          name: "EplNewTransactionSuccess",
          component: EplNewTransactionSuccess,
          props: true,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          path: ":type/Failed",
          name: "EplNewTransactionFail",
          component: EplNewTransactionFail,
          props: true,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          path: ":type/Pending",
          name: "EplNewTransactionPending",
          component: EplNewTransactionPending,
          props: true,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        }
      ]
    },
    {
      path: "/postpaid",
      meta: {
        requiresAuth: true,
        v1: true,
        v2: true
      },
      name: "postpaid",
      component: Postpaid,
      children: [
        {
          path: ":category",
          redirect: ":category/state",
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          path: ":category/state",
          name: "State",
          component: State,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":category/board",
          name: "Board",
          component: Board,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":category/fetch-bill",
          name: "FetchBill",
          component: FetchBill,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":category/bill",
          name: "Bill",
          component: Bill,
          props: true,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
          // meta: { layout: 'eplNew' }
        },
        {
          path: ":category/TransactionStatus",
          name: "Postpaid Transaction Status",
          component: TransactionStatus,
          meta: {
            requiresAuth: true,
            v1: true,
            v2: true
          }
        }
      ]
    },
    {
      path: "/v2/",
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      },
      name: "Dashboard",
      component: EplNewDashboard,
      children: [
        {
          path: "Mobile",
          name: "MobileWeb",
          component: MobileWeb,
          meta: {
            value: "Mobile",
            title: "Mobile Prepaid",
            pageTitle: "Mobile Recharge",
            v1: false,
            v2: true,
            requiresAuth: true
          },
          props: true
        },
        {
          path: "DTH",
          name: "DTHWeb",
          component: DTHWeb,
          meta: {
            value: "DTH",
            title: "DTH",
            pageTitle: "DTH Recharge",
            v1: false,
            v2: true,
            requiresAuth: true
          },
          props: true
        },
        {
          path: "DataCard",
          name: "DataCardWeb",
          component: DataCardWeb,
          meta: {
            value: "DataCard",
            title: "Data Card",
            pageTitle: "Data Card Recharge",
            v1: false,
            v2: true,
            requiresAuth: true
          },
          props: true
        },
        {
          path: ":category/choose-plan-web",
          name: "ChoosePlanWeb",
          component: ChoosePlanWeb,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/RechargeSuccess",
          name: "EplNewPaymentSuccess",
          component: EplNewPaymentSuccess,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/RechargeFailed",
          name: "EplNewPaymentFailure",
          component: EplNewPaymentFailure,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/RechargePending",
          name: "EplNewPaymentPending",
          component: EplNewPaymentPending,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/state",
          name: "StateWeb",
          component: StateWeb,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/board",
          name: "BoardWeb",
          component: BoardWeb,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/fetch-bill",
          name: "FetchBillWeb",
          component: FetchBillWeb,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/TransactionStatus",
          name: "TransactionStatusweb",
          component: TransactionStatusWeb,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: "pay-now",
          name: "Pay Now",
          component: EplNewPayNow,
          meta: {
            overlay: true,
            v1: false,
            v2: true
          }
        },
        {
          path: "view-details",
          name: "View Details",
          component: EplNewViewDetails,
          meta: {
            overlay: true,
            v1: false,
            v2: true
          }
        },
        {
          path: "pay-custom",
          name: "Pay Custom",
          component: EplNewPayCustom,
          meta: {
            overlay: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/pay-bill",
          name: "PostpaidWeb",
          component: PostpaidWeb,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        },
        {
          path: ":category/bill-web",
          name: "Bill Web",
          component: BillWeb,
          props: true,
          meta: {
            requiresAuth: true,
            v1: false,
            v2: true
          }
        }
      ]
    },
    {
      path: "/v2/payment",
      meta: {
        requiresAuth: true,
        layout: "eplNew",
        v1: false,
        v2: true
      },
      name: "Payment",
      component: EplNewPayment
    },
    {
      path: "/v2/transaction",
      meta: {
        requiresAuth: true,
        layout: "eplNew",
        v1: false,
        v2: true
      },
      name: "Transaction",
      component: EplNewTransaction,
      props: true
    },
    {
      path: "/v2/statement",
      component: EplNewStatementFilter,
      meta: {
        requiresAuth: true,
        layout: "eplNew",
        v1: false,
        v2: true
      },
      children: [
        {
          path: "/",
          redirect: "All",
          meta: {
            requiresAuth: true,
            layout: "eplNew",
            v1: false,
            v2: true
          }
        },
        {
          path: ":statementType",
          name: "My Statements",
          component: EplNewStatement,
          meta: {
            requiresAuth: true,
            layout: "eplNew",
            v1: false,
            v2: true
          }
        }
      ]
    },
    {
      name: "ProfileV2",
      path: "/v2/profile",
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      },
      component: EplNewProfile
    },
    {
      path: "/v2/invite-upgrade",
      name: "InviteAndUpgradeV2",
      component: EplNewInviteAndUpgrade,
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      }
    },
    {
      path: "/v2/reward-points",
      name: "RewardPointsV2",
      component: EplNewRewardPoints,
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      }
    },
    {
      path: "/v2/merchants",
      name: "MerchantsV2",
      component: EplNewMerchants,
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      }
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/verify-otp",
      name: "Verify OTP",
      component: SignupVerifyOTP,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Signup,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/login/verify-otp",
      name: "Login Verify OTP",
      component: SignupVerifyOTP,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: true,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/personal-details",
      name: "Personal Details",
      component: SignupPersonalDetails,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/employment-details",
      name: "Employment Details",
      component: SignupEmploymentDetails,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/verify-email-otp",
      name: "Verify Email OTP",
      component: SignupVerifyOTPEmail,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/loader",
      name: "Loading",
      component: SignupLoader,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/success",
      name: "Success",
      component: SignupSuccess,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/failure",
      name: "Failure",
      component: SignupFailure,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/pending",
      name: "Pending",
      component: SignupPending,
      meta: {
        layout: "signup",
        requiresAuth: false,
        showLeftSectionSmall: false,
        v1: true,
        v2: true
      }
    },
    {
      path: "/signup/eMandate",
      name: "eMandate",
      component: eMandate,
      meta: {
        layout: "signup",
        requiresAuth: true,
        showLeftSectionSmall: false,
        name: "KYC",
        v1: true,
        v2: true
      },
      children: [
        {
          name: "eMandate Success",
          path: "success",
          component: eMandateSuccess,
          meta: {
            layout: "signup",
            showLeftSectionSmall: false,
            name: "KYC",
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          name: "eMandate Failure",
          path: "failure",
          component: eMandateFailure,
          meta: {
            layout: "signup",
            showLeftSectionSmall: false,
            name: "KYC",
            requiresAuth: true,
            v1: true,
            v2: true
          }
        },
        {
          name: "eMandate Pending",
          path: "pending",
          component: eMandatePending,
          meta: {
            layout: "signup",
            showLeftSectionSmall: false,
            name: "KYC",
            requiresAuth: true,
            v1: true,
            v2: true
          }
        }
      ]
    },
    {
      path: "/signup/kyc",
      name: "Signup KYC",
      component: SignupKyc,
      meta: {
        layout: "signup",
        requiresAuth: true,
        showLeftSectionSmall: false,
        name: "KYC",
        v1: true,
        v2: true
      },
      children: [
        {
          path: "step-1",
          name: "KYC Step 1",
          component: SignupKycStep1,
          alias: "",
          meta: {
            layout: "signup",
            requiresAuth: true,
            showLeftSectionSmall: false,
            name: "KYC",
            v1: true,
            v2: true
          }
        },
        {
          path: "step-2",
          name: "KYC Step 2",
          component: SignupKycStep2,
          meta: {
            layout: "signup",
            requiresAuth: true,
            showLeftSectionSmall: false,
            name: "KYC",
            v1: true,
            v2: true
          }
        },
        {
          path: "success",
          name: "KYC Success",
          component: kycSuccess,
          meta: {
            layout: "signup",
            requiresAuth: true,
            showLeftSectionSmall: false,
            name: "KYC",
            v1: true,
            v2: true
          }
        },
        {
          path: "failure",
          name: "KYC Failure",
          component: kycFailure,
          meta: {
            layout: "signup",
            requiresAuth: true,
            showLeftSectionSmall: false,
            name: "KYC",
            v1: true,
            v2: true
          }
        }
      ]
    },
    {
      name: "Signup Blocked",
      path: "/signup/blocked",
      component: SignupBlocked,
      meta: {
        requiresAuth: false,
        v1: true,
        v2: true
      }
    },
    {
      name: "Bill Payments & Recharge History",
      path: "/transaction-history",
      component: TransactionHistory,
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true,
        layout: "eplNew"
      }
    },
    {
      name: "Insurance",
      path: "/covid-insurance",
      component: Insurance,
      meta: {
        requiresAuth: true,
        v1: false,
        v2: true
      }
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (localStorage.getItem("version")) {
      versionInterceptor(to, next);
    } else {
      $store
        .dispatch("getUser")
        .then(() => versionInterceptor(to, next))
        .catch(() =>
          next({ name: "Signup", query: { redirect: to.fullPath } })
        );
    }
  } else {
    next();
  }
});

function versionInterceptor(to, next) {
  if (to.matched.some(record => record.meta.v2 && record.meta.v1)) {
    next();
  } else if (to.matched.some(record => record.meta.v2)) {
    if (localStorage.getItem("version") === "epaylaterv2") {
      next();
    } else {
      next({
        name: "Home",
        query: { redirect: to.fullPath }
      });
    }
  } else if (to.matched.some(record => record.meta.v1)) {
    if (localStorage.getItem("version") === "epaylaterv2") {
      next({
        name: "Dashboard",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js